import Vue from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css'
import '@/styles/index.scss'
import '@/styles/chart.scss'

import '@/icons' // icon
import '@/utils/permission' // permission control
import wtConst from '@/utils/constants'
import wtUtil from '@/utils/wtUtil'
import wtValidator from '@/utils/wtValidator'
import components from '@/components'
import moduleComponents from '@/modules'
import echarts from 'echarts'
import api from '@/utils/api.js'
import dateFormat from '@/utils/dateFormat.js'
import '@/filters'


Vue.prototype.$wtUtil = wtUtil
Vue.prototype.$wtValidator = wtValidator
Vue.prototype.$wtConst = wtConst
Vue.prototype.$echarts = echarts
Vue.prototype.$api = api
Vue.prototype.$dateFormat = dateFormat
Object.keys(components).forEach(key => {
  const component = components[key]
  Vue.component(component.name, component)
})
Object.keys(moduleComponents).forEach(key => {
  const component = moduleComponents[key]
  Vue.component(component.name, component)
})

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
